<!-- Displays readonly value of the ORG UUID to prevent accidental editing (must click on edit toggle to start editing) -->
<!-- Note: only visible if "showEditToggle" is true -->
<div [hidden]="showEditToggle() ? isEditing : true">
  <div style="display: flex">
    <div style="flex: 1 0 auto; margin-left: 5px; display: flex; align-items: center">
      <span>{{ value?.orgUUID ?? "" }}</span>
    </div>
    <div style="flex: 0 1 auto">
      <button (click)="handleEdit()" class="edit-icon-btn" mat-button>
        <mat-icon class="just-icon">edit</mat-icon>
      </button>
    </div>
  </div>
</div>

<div [hidden]="!isEditing">
  <div style="display: flex">
    <mat-form-field style="width: 100%">
      <mat-label>Camera UUID</mat-label>
      <input matInput [formControl]="control" [matAutocomplete]="auto" />
    </mat-form-field>

    <!-- These controls are only relevant & visible if "showEditToggle" is true -->
    @if (showEditToggle()) {
      <div style="flex: 0 0 auto; display: flex; align-items: flex-end">
        <button class="edit-icon-btn" [disabled]="isUpdating" (click)="handleCancel()" mat-button>
          <mat-icon class="just-icon">cancel</mat-icon>
        </button>
      </div>
    }

    <!-- These controls are only relevant & visible if "showEditToggle" is true -->
    @if (showEditToggle()) {
      <div style="flex: 0 0 auto; display: flex; align-items: flex-end">
        <button class="edit-icon-btn" [class.spinner]="isUpdating" [disabled]="isUpdating" (click)="handleSave()" mat-button>
          <mat-icon class="just-icon">done</mat-icon>
        </button>
      </div>
    }
  </div>
</div>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onOptionSelect($event)">
  @for (option of filteredOptions | async; track option) {
    <mat-option [value]="option"> {{ option.orgUUID }} ({{ option.clientName }}) </mat-option>
  }
</mat-autocomplete>

@if (errorMessage) {
  <div style="white-space: pre-wrap; font-size: 10px; color: red">
    {{ errorMessage }}
  </div>
}
